import type { VanillaLinkProps } from '@_/ui';
import type { TextPostContainerProps } from '../TextPost/index.ts';
import { FormattedMessage } from 'react-intl';
import { Heading, Text } from '@_/ui';
import { TextPostContainer } from '../TextPost/index.ts';

export type ArticleFeedItemProps = Omit<TextPostContainerProps, 'children'> & {
  renderTitleLink?: (props: VanillaLinkProps) => React.ReactNode;
};

export function ArticleFeedItem({ post, renderTitleLink, ...otherProps }: ArticleFeedItemProps) {
  const title = <Heading level={6}>{post.title}</Heading>;

  const header = renderTitleLink?.({ children: title, plain: true }) || title;

  const readArticleLink = renderTitleLink?.({
    children: <FormattedMessage id="component:button.read-article" defaultMessage="Read article" />,
    className: 'font-semibold',
    plain: true,
    underline: true
  });

  return (
    <TextPostContainer {...otherProps} post={post}>
      {header}
      <Text block className="mt-1.5">
        {post.contentPreviewText}
        {!!readArticleLink && <span> {readArticleLink}</span>}
      </Text>
    </TextPostContainer>
  );
}
